var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldArrowSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm3.12 15.29c-.08.18-.22.33-.41.41a.717.717 0 0 1-.58 0 .776.776 0 0 1-.24-.16l-2.95-2.95a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.67 1.67V7c0-.41.34-.75.75-.75s.76.34.76.75v10c0 .1-.02.19-.06.29zm5.78-6.59c-.19 0-.38-.07-.53-.22l-1.67-1.67V17c0 .41-.34.75-.75.75s-.75-.34-.75-.75V7c0-.1.02-.19.06-.29.08-.18.22-.33.41-.41.18-.08.39-.08.57 0 .09.04.17.09.24.16l2.95 2.95c.29.3.29.78 0 1.07-.15.15-.34.22-.53.22z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldArrowSwap);
export default __webpack_public_path__ + "static/media/vuesax-bold-arrow-swap.16c1bce6152e6cf9326bc9c204cfc042.svg";
export { ForwardRef as ReactComponent };